import { Input, InputProps } from "@/components/Input";
import { BuilderBlockProps, CallbackReturnType } from "@/types";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { ChangeEvent, FC, useEffect, useRef } from "react";

type RadioInputBlockProps = Omit<
  Extract<InputProps, { type: "radio" }>,
  "onChange"
> & {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => CallbackReturnType;
  onChangeState?: (event: unknown) => CallbackReturnType;
} & Pick<BuilderProps, "builderContext"> &
  BuilderBlockProps;
export const RadioInputBlock: FC<RadioInputBlockProps> = ({
  children: _,
  attributes,
  builderContext,
  onChangeState,
  ...props
}) => {
  const radioRef = useRef<HTMLElement | null>(null);
  useEffect(() => {
    if (onChangeState) {
      const elem = radioRef.current;
      elem?.addEventListener("changeState", onChangeState);

      return () => {
        elem?.removeEventListener("changeState", onChangeState);
      };
    }
  }, [onChangeState]);

  const onValueChange = async (event: ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) {
      await props.onChange(event);
    }
  };

  return (
    <Input {...attributes} {...props} type="radio" onChange={onValueChange} />
  );
};
